import Error404 from "@/views-core/error/Error404.vue";
import ForgotPassword from "views/auth/ForgotPassword.vue";
import PasswordReset from "views/auth/PasswordReset.vue";
import EstablecerContrasena from "views/auth/EstablecerContrasena.vue";
import NotAuthorized from "@/views-core/pages/miscellaneous/NotAuthorized.vue";
import useRolStore from "@/store/rol";
import usePermisoStore from "@/store/permiso";
import useSistemaStore from "@/store/sistema";
import useIdiomaStore from "@/store/idioma";
import useUsuarioStore from "@/store/usuario";
import useCuponStore from "@/store/cupon";
import useTipoBiografiaStore from "@/store/TipoBiografia.js";
import useSeccionStore from "@/store/seccion";
import usePreguntaStore from "@/store/pregunta";
import useLoteStore from "@/store/lote";
import useDescuentoStore from "@/store/descuento";
import usePlanStore from "../../store/plan";
import usePapelStore from "@/store/papel";
import useEntrevistaStore from "@/store/entrevista";
import useCuestionarioStore from "@/store/cuestionario";
import useBiografiaStore from "@/store/biografia";
import useConfiguracionStore from "@/store/configuracion";
import useVideoStore from "@/store/video";
import useInvitacionStore from "@/store/invitacion";
import useContenidoStore from "@/store/contenido";
import useCategoriaStore from "@/store/categoria";
import useConfiguracion from "views/biografias/useConfiguracion";
import useProductoStore from "@/store/producto";
import useMaterialStore from "../../store/material";
import useFaqStore from "@/store/faq";
import useObjetivoStore from "@/store/objetivo";
import useRegaloStore from "@/store/regalo";
import useChatStore from "@/store/chat";
import useAutorStore from "@/store/autor";
import useEncargoStore from "@/store/encargo";
import useSolicitudEncargoStore from "@/store/solicitudEncargo";
import useAuth from "@utils/useAuth";

const fetchProducto = (id) => {
  const producto_store = useProductoStore();

  return new Promise((resolve, reject) => {
    producto_store
      .fetch(id)
      .then((data) => {
        if (data.id) {
          producto_store.setProducto(data);
        }
        resolve(data);
      })
      .catch((e) => reject(e));
  });
};

const ViewsComponent = () => import("components/Views.vue");

export default [
  {
    path: "/home",
    name: "home",
    component: () => import("views/home.vue"),
    beforeEnter: (to, from, next) => {
      const configuracion_store = useConfiguracionStore();
      configuracion_store.clear();
      next();
    },

    meta: {
      resource: "Home",
      action: "read",
    },
  },

  {
    path: "/login",
    name: "login",
    component: () => import("@/views-core/pages/authentication/Login.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
      action: "read",
    },
  },

  {
    path: "/registro",
    name: "registro",
    component: () => import("views/auth/registro.vue"),
    meta: {
      layout: "full",
      resource: "Auth",
      redirectIfLoggedIn: true,
      action: "read",
    },
  },

  {
    path: "/forgot-password",
    name: "auth-forgot-password",
    component: ForgotPassword,
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
      redirectIfLoggedIn: true,
    },
  },

  {
    path: "/error-404",
    name: "error-404",
    component: Error404,
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  {
    path: "/reset-password",

    props: (route) => ({
      token: route.query.token,
      email: route.query.email,
    }),
    name: "auth-reset-password",
    component: PasswordReset,
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
      redirectIfLoggedIn: true,
    },
  },

  {
    path: "/usuario/:usuario/establecer/contrasena",
    props: true,
    name: "establecer-contrasena",
    component: EstablecerContrasena,
    beforeEnter: (to, from, next) => {
      // Verificamos si el usuario ya ha establecido o no su contraseña al menos una vez

      const usuario_store = useUsuarioStore();

      usuario_store
        .verificarEstatus(to.params.usuario)
        .then(({ activo, is_password }) => {
          if (activo || is_password) {
            // si el usuario está activo o ya tiene password, no puede volver a establacer contraseña, mandamos a login
            toast.error("No puedes establecer contraseña a este usuario");
            next({ name: "login" });
          }
          return next(); // si no, que siga con el establecimiento
        })
        .catch((e) => {
          next({ name: "login" });
        });
    },

    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  {
    path: "/module/access-not-authorized",
    name: "misc-not-authorized",
    component: NotAuthorized,
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  /*****************************************/
  /* MI Perfil
  /*************************************** */

  {
    path: "/perfil",
    name: "mi-perfil",
    component: () => import("views/perfil/index.vue"),
    meta: {
      pageTitle: "Mi perfil",
      resource: "Perfil",
      action: "read",
      breadcrumb: [
        {
          text: "Configuración de perfil",
          active: true,
        },
      ],
    },
  },

  /*****************************************/
  /* USUARIO
   /*************************************** */

  {
    path: "/usuarios",
    component: ViewsComponent,
    children: [
      // Autores
      {
        path: "",
        name: "listar.autores",
        props: (route) => ({
          tipo: "autores",
        }),
        component: () => import("views/usuarios/lists.vue"),
        meta: {
          resource: "Autores",
          action: "read",
          pageTitle: "Autores",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
        },
      },

      // Autor por encargo
      {
        path: "",
        name: "listar.autores_por_encargo",
        props: (route) => ({
          tipo: "autores_por_encargo",
        }),
        component: () => import("views/usuarios/lists.vue"),
        meta: {
          resource: "Autores por encargos",
          action: "read",
          pageTitle: "Autores por encargos",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
        },
      },

      // Promotores
      {
        path: "",
        name: "listar.promotores",
        props: (route) => ({
          tipo: "promotores",
        }),
        component: () => import("views/usuarios/lists.vue"),
        meta: {
          resource: "Promotores",
          action: "read",
          pageTitle: "Partners",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
        },
      },

      // Administradores
      {
        path: "",
        name: "listar.administradores",
        props: (route) => ({
          tipo: "administradores",
        }),
        component: () => import("views/usuarios/lists.vue"),
        meta: {
          resource: "Administradores",
          action: "read",
          pageTitle: "Administradores",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
        },
      },

      {
        path: "create",
        name: "create.usuario",
        props: (route) => ({
          tipo: route.query.tipo,
        }),
        component: () => import("views/usuarios/create.vue"),
        meta: {
          pageTitle: `Registrar nuevo usuario`,
          navActiveLink: (q) => {
            if (q.tipo) {
              if (q.tipo === "autores") {
                return "listar.autores";
              } else if (q.tipo === "promotores") {
                return "listar.promotores";
              } else if (q.tipo === "administradores") {
                return "listar.administradores";
              }
            }
          },
          resource: "Usuarios",
          action: "write",
          breadcrumb: [
            {
              text: (route) => {
                const tipo = route.query.tipo;
                if (tipo) {
                  if (tipo === "autores") {
                    return "Autores";
                  } else if (tipo === "promotores") {
                    return "Promotores";
                  } else if (tipo === "administradores") {
                    return "Administradores";
                  }
                }
              },
              active: false,
              to: (route) => {
                const tipo = route.query.tipo;
                if (tipo) {
                  if (tipo === "autores") {
                    return { name: "listar.autores" };
                  } else if (tipo === "promotores") {
                    return { name: "listar.promotores" };
                  } else if (tipo === "administradores") {
                    return { name: "listar.administradores" };
                  }
                } else {
                  return { name: "listar.autores" };
                }
              },
            },

            {
              text: "crear",
              active: true,
            },
          ],
        },
      },
      {
        path: ":id/edit",
        name: "edit.usuario",
        props: (route) => ({
          tipo: route.query.tipo,
          id: route.params.id,
        }),
        component: () => import("views/usuarios/edit.vue"),
        beforeEnter: (to, from, next) => {
          const usuario_store = useUsuarioStore();
          usuario_store
            .fetch(to.params.id)
            .then((data) => {
              if (data) {
                next();
              } else {
                next({ name: "error-404" });
              }
            })
            .catch((e) => next({ name: "error-404" }));
        },

        meta: {
          pageTitle: `Editar regitro de usuario`,
          navActiveLink: (q) => {
            let tipo = q.tipo || "";
            if (tipo) {
              if (tipo === "autores") {
                return "listar.autores";
              } else if (tipo === "promotores") {
                return "listar.promotores";
              } else if (tipo === "administradores") {
                return "listar.administradores";
              }
            }
          },
          resource: "Usuarios",
          action: "update",
          breadcrumb: [
            {
              text: (route) => {
                const tipo = route.query.tipo;
                if (tipo) {
                  if (tipo === "autores") {
                    return "Autores";
                  } else if (tipo === "promotores") {
                    return "Promotores";
                  } else if (tipo === "administradores") {
                    return "Administradores";
                  }
                }
              },
              active: false,
              to: (route) => {
                if (!route.query.tipo) return { name: "listar.autores" };

                const tipo = route.query.tipo;
                if (tipo) {
                  if (tipo === "autores") {
                    return { name: "listar.autores" };
                  } else if (tipo === "promotores") {
                    return { name: "listar.promotores" };
                  } else if (tipo === "administradores") {
                    return { name: "listar.administradores" };
                  } else {
                    return { name: "listar.autores" };
                  }
                } else {
                  return { name: "listar.promotores" };
                }
              },
            },

            {
              text: "Editar",
              active: true,
            },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Mis Cupones
   /*************************************** */
  {
    path: "/mis-cupones",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "mis.cupones",
        props: (route) => ({
          isPartner: true,
        }),

        component: () => import("views/cupones/codigos.vue"),
        meta: {
          pageTitle: "Mis Cupones",
          resource: "Cupones",
          action: "read",
          breadcrumb: [{ text: "Mis Cupones", active: true }],
        },
      },
    ],
  },

  /*****************************************/
  /* ROL DE USUARIO
   /*************************************** */

  {
    path: "/roles",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "listar.roles",
        component: () => import("views/roles/lists.vue"),
        meta: {
          pageTitle: "Rol de usuarios",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
          resource: "Roles",
          action: "read",
        },
      },
      {
        path: "create",
        name: "create.role",
        component: () => import("views/roles/create.vue"),
        meta: {
          pageTitle: "Crear Rol",
          navActiveLink: "listar.roles",
          breadcrumb: [
            {
              text: "Rol de usuarios",
              active: false,
              to: { name: "listar.roles" },
            },

            {
              text: "Crear",
              active: true,
            },
          ],
          resource: "Roles",
          action: "write",
        },
      },
      {
        path: ":id/edit",
        props: true,
        name: "edit.role",
        component: () => import("views/roles/edit.vue"),
        beforeEnter: (to, from, next) => {
          const rol_store = useRolStore();
          const { fetch: fetchRol } = rol_store;
          fetchRol(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Editar Rol",
          navActiveLink: "listar.roles",
          breadcrumb: [
            {
              text: "Rol de usuarios",
              active: false,
              to: { name: "listar.roles" },
            },

            {
              text: "Editar",
              active: true,
            },
          ],
          resource: "Roles",
          action: "update",
        },
      },
    ],
  },

  /*****************************************/
  /* Tipo de Biografías
   /*************************************** */

  {
    path: "/tipo-biografias",
    component: ViewsComponent,
    exact: false,
    children: [
      {
        path: "",
        name: "listar.tipo_biografias",
        component: () => import("views/tipos-biografias/lists.vue"),
        meta: {
          pageTitle: "Tipos de Biografías",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
          resource: "Tipos de biografías",
          action: "read",
        },
      },
      {
        path: "create",
        name: "create.tipo_biografias",
        component: () => import("views/tipos-biografias/create.vue"),
        meta: {
          pageTitle: "Crear Tipo de Biografía",
          navActiveLink: "listar.tipo_biografias",
          breadcrumb: [
            {
              text: "Tipos de biografías",
              active: false,
              to: { name: "listar.tipo_biografias" },
            },

            {
              text: "Crear",
              active: true,
            },
          ],
          resource: "Tipos de biografías",
          action: "write",
        },
      },
      {
        path: ":id/edit",
        props: true,
        name: "edit.tipo_biografias",
        component: () => import("views/tipos-biografias/edit.vue"),
        beforeEnter: (to, from, next) => {
          const tipo_store = useTipoBiografiaStore();
          const { fetch: fetchTipo } = tipo_store;
          fetchTipo(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Editar Tipo de Biografía",
          navActiveLink: "listar.tipo_biografias",
          breadcrumb: [
            {
              text: "Tipos de Biografías",
              active: false,
              to: { name: "listar.tipo_biografias" },
            },

            {
              text: "Editar",
              active: true,
            },
          ],
          resource: "Tipos de biografías",
          action: "update",
        },
      },

      // Secciones
      {
        path: ":bio/secciones",
        component: ViewsComponent,
        props: true,

        children: [
          {
            path: "",
            name: "seccion_list",
            component: () =>
              import("views/tipos-biografias/secciones/lists.vue"),
            props: true,
            meta: {
              resource: "Secciones de biografías",
              action: "read",
              pageTitle: "Secciones de biografías",
              navActiveLink: "listar.tipo_biografias",
              breadcrumb: [
                {
                  text: "Tipos de Biografías",
                  active: false,
                  to: { name: "listar.tipo_biografias" },
                },

                {
                  text: "Secciones",
                  active: true,
                },
              ],
            },
          },

          {
            path: "create",
            name: "create.seccion",
            component: () =>
              import("views/tipos-biografias/secciones/create.vue"),
            props: true,
            meta: {
              pageTitle: "Asignar sección",
              navActiveLink: "listar.tipo_biografias",
              breadcrumb: [
                {
                  text: "Tipos de biografías",
                  active: false,
                  to: { name: "listar.tipo_biografias" },
                },

                {
                  text: "Secciones",
                  active: false,
                },

                {
                  text: "Crear",
                  active: true,
                },
              ],
              resource: "Secciones de biografías",
              action: "write",
            },
          },

          {
            path: ":id/edit",
            name: "edit.seccion",
            component: () =>
              import("views/tipos-biografias/secciones/edit.vue"),
            props: true,
            beforeEnter: (to, from, next) => {
              const seccion_store = useSeccionStore();
              seccion_store.fetch(to.params.id).then(({ id }) => {
                if (id) {
                  next();
                }
              });
            },

            meta: {
              pageTitle: "Editar sección",
              navActiveLink: "listar.tipo_biografias",
              breadcrumb: [
                {
                  text: "Tipos de biografías",
                  active: false,
                  to: { name: "listar.tipo_biografias" },
                },

                {
                  text: "Secciones",
                  active: false,
                },

                {
                  text: "Editar",
                  active: true,
                },
              ],
              resource: "Secciones de biografías",
              action: "update",
            },
          },
        ],
      },
    ],
  },

  /*****************************************/
  /* Cuestionarios
  /*****************************************/
  {
    path: "/cuestionarios",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "cuestionario.list",
        component: () => import("views/cuestionarios/list.vue"),
        meta: {
          pageTitle: "Cuestionarios",
          resource: "Cuestionarios",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "cuestionario.create",
        component: () => import("views/cuestionarios/create.vue"),
        meta: {
          pageTitle: "Crear Cuestionario",
          resource: "Cuestionarios",
          action: "write",
          navActiveLink: "cuestionario.list",
          breadcrumb: [
            {
              text: "Cuestionarios",
              active: false,
              to: { name: "cuestionario.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "cuestionario.edit",
        component: () => import("views/cuestionarios/edit.vue"),
        beforeEnter: (to, from, next) => {
          const cuestionario_store = useCuestionarioStore();
          cuestionario_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Editar Cuestionario",
          resource: "Cuestionarios",
          action: "update",
          navActiveLink: "cuestionario.list",
          breadcrumb: [
            {
              text: "Cuestionarios",
              active: false,
              to: { name: "cuestionario.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":cuestionarioId/preguntas",
        name: "cuestionario.preguntas",
        props: true,
        component: () => import("views/cuestionarios/preguntas.vue"),
        meta: {
          pageTitle: "Preguntas del Cuestionario",
          resource: "Cuestionarios",
          action: "write",
          navActiveLink: "cuestionario.list",
          breadcrumb: [
            {
              text: "Cuestionarios",
              active: false,
              to: { name: "cuestionario.list" },
            },
            { text: "Preguntas", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Preguntas
  /*************************************** */
  {
    path: "/preguntas",
    component: ViewsComponent,
    children: [
      {
        path: "",
        component: () => import("views/preguntas/list.vue"),
        name: "preguntas.list",
        meta: {
          pageTitle: "Preguntas",
          resource: "Preguntas",
          action: "read",
          breadcrumb: [{ text: "Preguntas", active: true }],
        },
      },

      {
        path: "create",
        component: () => import("views/preguntas/create.vue"),
        name: "create.pregunta",
        meta: {
          pageTitle: "Registrar Pregunta",
          resource: "Preguntas",
          action: "write",
          navActiveLink: "preguntas.list",
          breadcrumb: [
            {
              text: "Preguntas",
              active: false,
              to: { name: "preguntas.list" },
            },
            { text: "Registrar Pregunta", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        props: true,
        component: () => import("views/preguntas/edit.vue"),
        name: "edit.pregunta",
        beforeEnter: (to, from, next) => {
          const pregunta_store = usePreguntaStore();

          pregunta_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Actualizar Registro de Pregunta",
          resource: "Preguntas",
          action: "update",
          navActiveLink: "preguntas.list",
          breadcrumb: [
            {
              text: "Preguntas",
              active: false,
              to: { name: "preguntas.list" },
            },
            { text: "Actualizar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* PERMISOS DE USUARIO
   /*************************************** */

  {
    path: "/permisos",
    component: ViewsComponent,
    exact: false,
    children: [
      {
        path: "",
        name: "listar.permisos",
        component: () => import("views/permisos/lists.vue"),
        meta: {
          pageTitle: "Permisos de usuario",
          breadcrumb: [
            {
              text: "Listado",
              active: true,
            },
          ],
          resource: "Permisos",
          action: "read",
        },
      },
      {
        path: "create",
        name: "create.permiso",
        component: () => import("views/permisos/create.vue"),
        meta: {
          pageTitle: "Crear Permiso",
          navActiveLink: "listar.permisos",
          breadcrumb: [
            {
              text: "Permisos de usuario",
              active: false,
              to: { name: "listar.permisos" },
            },

            {
              text: "Crear",
              active: true,
            },
          ],
          resource: "Permisos",
          action: "write",
        },
      },
      {
        path: ":id/edit",
        props: true,
        name: "edit.permiso",
        component: () => import("views/permisos/edit.vue"),
        beforeEnter: (to, from, next) => {
          const permiso_store = usePermisoStore();
          permiso_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Editar Permiso",
          navActiveLink: "listar.permisos",
          breadcrumb: [
            {
              text: "Permisos de usuario",
              active: false,
              to: { name: "listar.permisos" },
            },

            {
              text: "Editar",
              active: true,
            },
          ],
          resource: "Permisos",
          action: "update",
        },
      },
    ],
  },

  /*****************************************/
  /* Soporte
   /****************************************/
  {
    path: "/soporte",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "soporte",
        component: () => import("views/soporte/index.vue"),
        meta: {
          pageTitle: "Soporte",
          pageSubtitle: "¿En qué podemos ayudarte?",
          resource: "Soporte",
          action: "read",
          breadcrumb: [{ text: "Soporte", active: true }],
        },
      },
    ],
  },

  /*****************************************/
  /* Academia
  /****************************************/
  {
    path: "/academia",
    name: "academia",
    component: () => import("views/academia/index.vue"),
    meta: {
      pageTitle: "Academia",
      pageSubtitle: "Cursos y tutoriales para ayudarte a tener éxito",
      resource: "Academia",
      action: "read",
      breadcrumb: [{ text: "Academia", active: true }],
    },
  },

  /*****************************************/
  /* Idiomas
   /****************************************/

  {
    path: "/idiomas",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "idioma.list",
        component: () => import("views/idiomas/list.vue"),
        meta: {
          pageTitle: "Idiomas del sistema",
          resource: "Idiomas",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "traduccions",
        name: "idioma.traducciones",
        props: (route) => ({ lang: route.query.lang }),
        component: () => import("views/idiomas/traducciones.vue"),
        meta: {
          pageTitle: "Traducciones del idioma",
          navActiveLink: "idioma.list",
          resource: "Idiomas",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "idioma.list" } },
            { text: "Traducciones", active: true },
          ],
        },
      },

      {
        path: "create",
        name: "idioma.create",
        component: () => import("views/idiomas/create.vue"),
        meta: {
          pageTitle: "Crear",
          resource: "Idiomas",
          navActiveLink: "idioma.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "idioma.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "idioma.edit",
        props: true,
        component: () => import("views/idiomas/edit.vue"),
        beforeEnter: (to, from, next) => {
          const idioma_store = useIdiomaStore();

          idioma_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },

        meta: {
          pageTitle: "Editar",
          resource: "Idiomas",
          navActiveLink: "idioma.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "idioma.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Lotes
   /****************************************/

  {
    path: "/lotes",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "lote.list",
        component: () => import("views/lotes/list.vue"),
        meta: {
          pageTitle: "Lotes de Páginas",
          resource: "Lotes",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "lote.create",
        component: () => import("views/lotes/create.vue"),
        meta: {
          pageTitle: "Crear",
          resource: "Lotes",
          navActiveLink: "lote.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "lote.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "lote.edit",
        props: true,
        component: () => import("views/lotes/edit.vue"),
        beforeEnter: (to, from, next) => {
          const lote_store = useLoteStore();

          lote_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },

        meta: {
          pageTitle: "Editar",
          resource: "Lotes",
          navActiveLink: "lote.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "lote.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Descuentos
   /****************************************/

  {
    path: "/descuentos",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "descuento.list",
        component: () => import("views/descuentos/list.vue"),
        meta: {
          pageTitle: "Descuentos",
          resource: "Descuentos",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "descuento.create",
        component: () => import("views/descuentos/create.vue"),
        meta: {
          pageTitle: "Crear",
          resource: "Descuentos",
          navActiveLink: "descuento.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "descuento.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "descuento.edit",
        props: true,
        component: () => import("views/descuentos/edit.vue"),
        beforeEnter: (to, from, next) => {
          const descuento_store = useDescuentoStore();

          descuento_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },

        meta: {
          pageTitle: "Editar",
          resource: "Descuentos",
          navActiveLink: "descuento.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "descuento.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Planes
   /****************************************/

  {
    path: "/plans",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "plan.list",
        component: () => import("views/plans/list.vue"),
        meta: {
          pageTitle: "Planes",
          resource: "Planes",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "plan.create",
        component: () => import("views/plans/create.vue"),
        meta: {
          pageTitle: "Registrar nuevo Plan",
          resource: "Planes",
          navActiveLink: "plan.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "plan.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "plan.edit",
        props: true,
        component: () => import("views/plans/edit.vue"),
        beforeEnter: (to, from, next) => {
          const plan_store = usePlanStore();

          plan_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },

        meta: {
          pageTitle: "Actualizar Plan",
          resource: "Planes",
          navActiveLink: "plan.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "plan.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Generador de Contenido
   /****************************************/
  {
    path: "/bio/:bio/contenidos/:id/generador",
    name: "generador-contenido",
    component: () => import("views/biografias/generadorContenido.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const bio_store = useBiografiaStore();
      bio_store.fetch(to.params.bio).then(({ id }) => {
        if (id) {
          const contenido_store = useContenidoStore();
          contenido_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        }
      });
    },

    meta: {
      resource: "Biografías",
      action: "read",
      pageTitle: "Generador de Contenido",
      navActiveLink: "biografia.list",
      layout: "vertical",
      breadcrumb: [
        { text: "Biografías", active: false, to: { name: "biografia.list" } },
        {
          text: "Estado de la Biografía",
          active: false,
          to: (route) => {
            return {
              name: "biografia.preview",
              params: {
                id: route.params.bio,
              },
            };
          },
        },
        { text: "Generador", active: true },
      ],
    },
  },

  /*****************************************/
  /* Hojas de Papel
   /****************************************/

  {
    path: "/configuracion/papels",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "papel.list",
        component: () => import("views/configuracion/papels/list.vue"),
        meta: {
          pageTitle: "Tamaño de Papel (Hojas)",
          resource: "Configuraciones",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "papel.create",
        component: () => import("views/configuracion/papels/create.vue"),
        meta: {
          pageTitle: "Crear",
          resource: "Configuraciones",
          navActiveLink: "papenl.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "papel.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "papel.edit",
        props: true,
        component: () => import("views/configuracion/papels/edit.vue"),
        beforeEnter: (to, from, next) => {
          const papel_store = usePapelStore();

          papel_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {
              console.log(e);
            });
        },

        meta: {
          pageTitle: "Editar",
          resource: "Configuraciones",
          navActiveLink: "papel.list",
          action: "read",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "papel.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Biografias 
  /*************************************** */

  {
    path: "/biografias",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "biografia.list",
        component: () => import("views/biografias/list.vue"),
        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Biografías",
        },
      },

      {
        path: "configurar",
        name: "biografia.configurar",
        props: (route) => ({
          interno: true,
        }),
        component: () => import("views/public/ComenzarBiografia.vue"),
        beforeEnter: (to, from, next) => {
          const store = useConfiguracionStore();
          const bio_store = useBiografiaStore();
          store.clear();
          bio_store.clear();
          next();
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Crear Biografía",
          // navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/configurar",
        name: "biografia.edit",
        component: () => import("views/biografias/configurar.vue"),
        props: true,
        beforeEnter: (to, from, next) => {
          const biografia_store = useBiografiaStore();
          biografia_store.fetch(to.params.id).then(({ id, biografiable }) => {
            if (id) {
              const configuracion_store = useConfiguracionStore();
              configuracion_store.setConfiguracion(biografiable);
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Configurar Biografía",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Configurar", active: true },
          ],
        },
      },

      {
        path: ":id/preview",
        name: "biografia.preview",
        component: () => import("views/biografias/preview.vue"),
        props: (route) => ({
          id: route.params.id,
          abierto: route.query.abierto || "",
        }),
        beforeEnter: (to, from, next) => {
          const biografia_store = useBiografiaStore();
          biografia_store.fetch(to.params.id).then(({ id, biografiable }) => {
            if (id) {
              const configuracion_store = useConfiguracionStore();
              configuracion_store.setConfiguracion(biografiable);

              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Estado de la Biografía",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Estados", active: true },
          ],
        },
      },

      {
        path: ":id/previsualizador",
        name: "previsualizador",
        props: true,
        component: () => import("views/biografias/previsualizador.vue"),

        beforeEnter: (to, from, next) => {
          const biografia_store = useBiografiaStore();
          biografia_store.previsualizar(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Previsualizador",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Vista Preview", active: true },
          ],
        },
      },

      {
        path: ":bio/pagina-dedicatoria",
        name: "pagina.dedicatoria",
        props: true,
        component: () => import("views/biografias/EditorDedicatoria.vue"),

        beforeEnter: (to, from, next) => {
          const contenido_store = useContenidoStore();
          contenido_store.getDedicatoria(to.params.bio).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Editor de Dedicatoria",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },

            { text: "Dedicatoria", active: true },
          ],
        },
      },

      {
        path: ":bio/pagina-autor",
        name: "pagina.autor",
        props: true,
        component: () => import("views/biografias/EditorSobreAutor.vue"),

        beforeEnter: (to, from, next) => {
          const contenido_store = useContenidoStore();
          contenido_store.getSobreAutor(to.params.bio).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Editor de Página acerca del Autor",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },

            { text: "Editor", active: true },
          ],
        },
      },

      {
        path: ":bio/pagina-derechos-autor",
        name: "pagina.derechos.autor",
        props: true,
        component: () => import("views/biografias/EditorDerechosAutor.vue"),
        beforeEnter: (to, from, next) => {
          const contenido_store = useContenidoStore();
          contenido_store.getDerechosAutor(to.params.bio).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Editor de Página Derechos de Autor",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            {
              text: "Estado de la Biografía",
              active: false,
              to: (route) => {
                return {
                  name: "biografia.preview",
                  params: {
                    id: route.params.bio,
                  },
                };
              },
            },

            { text: "Editor", active: true },
          ],
        },
      },

      {
        path: ":id/visor-ebook",
        name: "visor.ebook",
        props: true,
        component: () => import("views/biografias/VisorEbook.vue"),
        beforeEnter: (to, from, next) => {
          const bio_store = useBiografiaStore();
          bio_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Visor Ebook",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            {
              text: "Estado de la Biografía",
              active: false,
              to: (route) => {
                return {
                  name: "biografia.preview",
                  params: {
                    id: route.params.bio,
                  },
                };
              },
            },

            { text: "Ebook", active: true },
          ],
        },
      },

      {
        path: ":id/entrevistas",
        name: "biografia.entrevistas",
        props: (route) => ({
          id: route.params.id,
          entrevistaId: route.query.entrevistaId || null,
          desdeIndice: route.query.desdeIndice || false,
        }),
        component: () => import("views/biografias/entrevistas/entrevistas.vue"),
        beforeEnter: (to, from, next) => {
          const biografia_store = useBiografiaStore();
          biografia_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) next();
            })
            .catch((e) => {
              next({ name: "biografia.list" });
            });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Entrevistas",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            {
              text: "Entrevistas",
              active: true,
            },
          ],
        },
      },

      {
        path: "publicar",
        name: "biografia.publicar",
        component: () =>
          import("views/biografias/entrevistas/RealizarEntrevista.vue"),
        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Crear Biografía",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":bio/show",
        name: "biografia.show",
        component: () => import("views/biografias/show.vue"),
        props: true,
        beforeEnter: (to, from, next) => {
          const biografia_store = useBiografiaStore();
          biografia_store.fetch(to.params.bio).then(({ id }) => {
            if (id) next();
          });
        },

        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Visor de Biografía",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Ver", active: true },
          ],
        },
      },

      /*****************************************/
      /* Entrevistas 
      /*************************************** */
      {
        path: "/entrevista/:entrevistaId/llenar",
        props: true,
        component: () =>
          import("views/biografias/entrevistas/RealizarEntrevista.vue"),
        name: "entrevista.llenar",
        beforeEnter: (to, from, next) => {
          const entrevista_store = useEntrevistaStore();
          if (entrevista_store.entrevista.id === to.params.entrevistaId) {
            next();
          } else {
            entrevista_store.fetch(to.params.entrevistaId).then(({ id }) => {
              if (id) next();
            });
          }
        },
        meta: {
          resource: "Biografías",
          action: "read",
          pageTitle: "Responder Entrevista",
          navActiveLink: "biografia.list",
          breadcrumb: [
            {
              text: "Biografías",
              active: false,
              to: { name: "biografia.list" },
            },
            { text: "Entrevista", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Portada
   /*************************************** */
  {
    path: "/portadas",
    component: ViewsComponent,

    children: [
      {
        path: "",
        name: "portada.list",
        component: () => import("views/portadas/list.vue"),
        meta: {
          pageTitle: "Portadas",
          resource: "Portadas",
          action: "read",
          navActiveLink: "portada.list",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: ":configId/configurar",
        name: "configurar.portada",
        component: () => import("views/portadas/configurar.vue"),
        props: (route) => ({
          configId: route.params.configId,
          posicion: route.query.posicion,
        }),
        beforeEnter: (to, from, next) => {
          const bio_store = useBiografiaStore();
          bio_store.fetchPorConfig(to.params.configId).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Configurar Portada",
          resource: "Portadas",
          action: "read",
          navActiveLink: "portada.list",
          breadcrumb: [
            {
              text: "Portadas",
              active: false,
              to: { name: "portada.list" },
            },
            { text: "Configurar", active: true },
          ],
        },
      },
    ],
  },
  /*****************************************/
  /* videos 
  /*************************************** */
  {
    path: "/videos",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "admin.videos.list",
        component: () => import("views/videos/list.vue"),
        meta: {
          pageTitle: "Vídeos de Ayuda",
          resource: "Vídeos de Ayuda",
          action: "write",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "crear",
        name: "video.create",
        component: () => import("views/videos/create.vue"),
        meta: {
          pageTitle: "Crear Vídeo de Ayuda",
          resource: "Vídeos de Ayuda",
          action: "write",
          navActiveLink: "admin.videos.list",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "admin.videos.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/editar",
        name: "video.edit",
        props: true,
        navActiveLink: "admin.videos.list",
        component: () => import("views/videos/edit.vue"),
        beforeEnter: (to, from, next) => {
          const video_store = useVideoStore();
          video_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Editar Vídeo de Ayuda",
          resource: "Vídeos de Ayuda",
          action: "update",
          navActiveLink: "admin.videos.list",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "admin.videos.list" },
            },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },
  /*****************************************/
  /* Colaboradores 
   /*************************************** */

  {
    path: "/colaboradores",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "colaboradores.list",
        component: () =>
          import("views/biografias/entrevistas/RealizarEntrevista.vue"),
        meta: {
          resource: "Colaboradores",
          action: "read",
          pageTitle: "Colaboradores",
        },
      },
      {
        path: "invitar",
        name: "colaborador.invitar",
        component: () =>
          import("views/biografias/entrevistas/RealizarEntrevista.vue"),
        meta: {
          resource: "Colaboradores",
          action: "read",
          pageTitle: "Realizar invitación",
          navActiveLink: "colaboradores.list",
          breadcrumb: [
            {
              text: "Colaboradores",
              active: false,
              to: { name: "colaboradores.list" },
            },
            { text: "Inivitar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Compras 
   /*************************************** */

  {
    path: "/compras",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "compra.list",
        component: () => import("views/compras/list.vue"),
        meta: {
          pageTitle: "Compras",
          resource: "Compras",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  /*****************************************/
  /* Precios 
   /*************************************** */

  {
    path: "/precios",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "precios",
        component: () =>
          import("views/biografias/entrevistas/RealizarEntrevista.vue"),
        meta: {
          resource: "Auth",
          action: "read",
          pageTitle: "Precios",
        },
      },
    ],
  },

  /*****************************************/
  /* Suscripciones 
  /*************************************** */
  {
    path: "/suscripciones",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "subscripcion.list",
        component: () => import("views/subscripciones/list.vue"),
        meta: {
          pageTitle: "Suscripciones & Facturación",
          resource: "Suscripciones",
          action: "read",
        },
      },
    ],
  },

  /*****************************************/
  /* Cupones 
  /*************************************** */

  {
    path: "/cupones",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "cupon.list",
        component: () => import("views/cupones/list.vue"),
        meta: {
          pageTitle: "Cupones",
          resource: "Cupones",
          action: "read",
          navActiveLink: "cupon.list",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "create",
        name: "cupon.create",
        component: () => import("views/cupones/create.vue"),
        meta: {
          pageTitle: "Crear Cupón",
          resource: "Cupones",
          action: "write",
          navActiveLink: "cupon.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "cupon.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":cuponId/codigos",
        name: "cupon.codigos",
        props: true,
        component: () => import("views/cupones/codigos.vue"),
        beforeEnter: async (to, from, next) => {
          const cupon_store = useCuponStore();
          const res = await cupon_store.fetch(to.params.cuponId);
          if (res && res.id) {
            next();
          } else {
            next({ name: "cupon.list" });
          }
        },
        meta: {
          pageTitle: "Códigos del Cupón",
          resource: "Cupones",
          action: "read",
          navActiveLink: "cupon.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "cupon.list" } },
            { text: "Códigos", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "cupon.edit",
        props: true,
        component: () => import("views/cupones/edit.vue"),
        beforeEnter: (to, from, next) => {
          const cupon_store = useCuponStore();
          cupon_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Actualizar Cupón",
          resource: "Cupones",
          action: "update",
          navActiveLink: "cupon.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "cupon.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },
  /*****************************************/
  /* Categorías de Productos 
  /*************************************** */
  {
    path: "/categorias",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "listar.categorias",
        component: () => import("views/categorias/list.vue"),
        meta: {
          pageTitle: "Categorías de Productos",
          resource: "Categorías de productos",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "create",
        name: "categoria.create",
        component: () => import("views/categorias/create.vue"),
        meta: {
          pageTitle: "Nuevo registro de categoría",
          resource: "Categorías de productos",
          action: "write",
          navActiveLink: "listar.categorias",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.categorias" },
            },
            {
              text: "Crear",
              active: true,
            },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "categoria.edit",
        props: true,
        beforeEnter: (to, from, next) => {
          const categoria_store = useCategoriaStore();
          categoria_store.fetch(to.params.id).then((data) => {
            if (data.id) {
              categoria_store.setCategoria(data);
              next();
            }
          });
        },

        component: () => import("views/categorias/edit.vue"),
        meta: {
          pageTitle: "Actualizar registro de categoría",
          resource: "Categorías de productos",
          action: "update",
          navActiveLink: "listar.categorias",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.categorias" },
            },
            {
              text: "Editar",
              active: true,
            },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Productos 
  /*************************************** */
  {
    path: "/productos",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "listar.productos",
        component: () => import("views/productos/list.vue"),
        meta: {
          pageTitle: "Productos",
          resource: "Productos",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "create",
        name: "producto.create",
        component: () => import("views/productos/create.vue"),
        meta: {
          pageTitle: "Nuevo registro de producto",
          resource: "Productos",
          action: "write",
          navActiveLink: "listar.productos",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.productos" },
            },
            {
              text: "Crear",
              active: true,
            },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "producto.edit",
        props: true,
        beforeEnter: (to, from, next) => {
          const producto_store = useProductoStore();
          producto_store.fetch(to.params.id).then((data) => {
            if (data.id) {
              producto_store.setProducto(data);
              next();
            }
          });
        },

        component: () => import("views/productos/edit.vue"),
        meta: {
          pageTitle: "Actualizar registro de producto",
          resource: "Productos",
          action: "update",
          navActiveLink: "listar.productos",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.productos" },
            },
            {
              text: "Editar",
              active: true,
            },
          ],
        },
      },

      {
        path: ":id/imagenes",
        name: "producto.imagenes",
        props: true,
        beforeEnter: (to, from, next) => {
          fetchProducto(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        component: () => import("views/productos/imagenes.vue"),
        meta: {
          pageTitle: "Imagenes del Producto",
          resource: "Productos",
          action: "update",
          navActiveLink: "listar.productos",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.productos" },
            },
            {
              text: "Productos",
              active: false,
              to: { name: "listar.productos" },
            },
            { text: "Imagenes", active: true },
          ],
        },
      },
      // Show
      {
        path: ":id/show",
        props: true,
        component: () => import("views/productos/perfil.vue"),
        name: "producto.show",
        beforeEnter: (to, from, next) => {
          fetchProducto(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          resource: "Productos",
          action: "read",
          pageTitle: "Producto",
          navActiveLink: "listar.productos",
          breadcrumb: [
            { text: "Home", to: { name: "home" }, active: false },
            {
              text: "Productos",
              active: false,
              to: { name: "listar.productos" },
            },
            { text: "Perfil", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Datos para recibir pagos 
  /*************************************** */
  {
    path: "/datos-pagos",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "datos-pagos.list",
        component: () => import("views/perfil/DatosPago.vue"),
        meta: {
          pageTitle: "Datos de Pago",
          resource: "Datos para recibir pagos",
          action: "read",
          navActiveLink: "datos-pagos.list",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  /*****************************************/
  /* Retiros
  /*************************************** */
  {
    path: "/retiros",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "retiros.list",
        component: () => import("views/retiros/list.vue"),
        meta: {
          pageTitle: "Retiros",
          resource: "Retiros",
          action: "read",
          navActiveLink: "retiros.list",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  /*****************************************/
  /* Sistema 
   /*************************************** */
  {
    path: "/sistema",
    name: "sistema",
    component: () => import("views/sistema.vue"),
    beforeEnter: (to, from, next) => {
      const sistema_store = useSistemaStore();

      sistema_store
        .fetch()
        .then(({ id }) => {
          if (id) {
            next();
          } else {
            next({ name: "home" });
          }
        })
        .catch((e) => {
          next({ name: "home" });
        });
    },
    meta: {
      pageTitle: "Sistema",
      resource: "Sistema",
      action: "read",
    },
  },

  /*****************************************/
  /* Configuracion de paypal 
  /*************************************** */
  {
    path: "/configuracions/paypal",
    name: "paypal",
    component: () => import("views/configuracions/paypal/paypal.vue"),
    meta: {
      pageTitle: "Paypal",
      pageSubtitle: "Gestiona tus configuraciones de paypal",
      resource: "Paypal",
      action: "read",
      navActiveLink: "paypal",
    },
  },

  /*****************************************/
  /* Página de Autors 
  /*************************************** */
  {
    path: "/autors/:slug",
    name: "autor.public",
    component: () => import("views/AutorPublic.vue"),
    props: true,
    beforeEnter: (to, from, next) => {
      const user_store = useUsuarioStore();
      user_store.fetchPublicAutor(to.params.slug).then((data) => {
        if (data && data.id) {
          next();
        } else {
          alert("sin encontrarse");
        }
      });
    },

    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  /*****************************************/
  /* Estado de cuentas
   /****************************************/
  {
    path: "/estado-cuenta",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "estado.cuentas",
        component: () => import("views/estado-cuentas/list.vue"),
        meta: {
          pageTitle: "Estado de Cuenta",
          resource: "Estado de cuentas",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  {
    path: "/billetera",
    name: "billetera",
    component: () => import("views/estado-cuentas/billetera.vue"),
    meta: {
      pageTitle: "Mi Billetera",
      resource: "Billetera",
      action: "read",
      breadcrumb: [{ text: "Movimientos de cuenta", active: true }],
    },
  },

  /*****************************************/
  /* Productos promocionales
   /****************************************/
  {
    path: "/productos-promocionales",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "productos.promocionales",
        component: () => import("views/productos/list.vue"),
        props: (rout) => ({
          isPromotor: true,
          isStore: true,
        }),
        meta: {
          pageTitle: "Catalogo de productos",
          resource: "Productos promocionales",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "producto/:id/show",
        props: (route) => ({
          isStore: route.query.isStore || false,
          id: route.params.id,
          isPromotor: true,
        }),
        component: () => import("views/productos/perfil.vue"),
        name: "producto.promocional.show",
        beforeEnter: (to, from, next) => {
          fetchProducto(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          resource: "Productos promocionales",
          action: "read",
          pageTitle: "Producto",
          navActiveLink: "productos.promocionales",
          breadcrumb: [
            {
              text: "Productos",
              active: false,
              to: { name: "productos.promocionales" },
            },
            {
              text: (route) => {
                const producto_store = useProductoStore();
                const { producto } = storeToRefs(producto_store);
                return producto.value.nombre;
              },
              active: true,
            },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Materiales promocionales
  /****************************************/
  {
    path: "/materiales-promocionales",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "materiales.promocionales",
        component: () => import("views/materiales-promocionales/list.vue"),
        meta: {
          pageTitle: "Materiales promocionales",
          resource: "Materiales promocionales",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },

      {
        path: "create",
        name: "material.create",
        component: () => import("views/materiales-promocionales/create.vue"),
        meta: {
          pageTitle: "Crear material promocional",
          resource: "Materiales promocionales",
          action: "write",
          navActiveLink: "materiales.promocionales",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "materiales.promocionales" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "material.edit",
        props: true,
        component: () => import("views/materiales-promocionales/edit.vue"),
        beforeEnter: (to, from, next) => {
          const material_store = useMaterialStore();
          material_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Editar material promocional",
          resource: "Materiales promocionales",
          action: "update",
          navActiveLink: "materiales.promocionales",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "materiales.promocionales" },
            },
            { text: "Editar", active: true },
          ],
        },
      },

      {
        path: ":id/show",
        props: (route) => ({
          id: route.params.id,
        }),
        component: () => import("views/materiales-promocionales/perfil.vue"),
        name: "material.show",
        beforeEnter: (to, from, next) => {
          const material_store = useMaterialStore();
          material_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          resource: "Materiales promocionales",
          action: "read",
          pageTitle: "Material promocional",
          navActiveLink: "materiales.promocionales",
          breadcrumb: [
            {
              text: "Materiales",
              active: false,
              to: { name: "materiales.promocionales" },
            },
            {
              text: (route) => {
                const material_store = useMaterialStore();
                const { material } = storeToRefs(material_store);
                return material.value.nombre;
              },
              active: true,
            },
          ],
        },
      },

      // /imagenes
      {
        path: ":id/imagenes",
        name: "material.imagenes",
        props: (route) => ({
          id: route.params.id,
          isMaterial: true,
        }),
        beforeEnter: (to, from, next) => {
          const material_store = useMaterialStore();
          material_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        component: () => import("views/productos/imagenes.vue"),
        meta: {
          pageTitle: "Imagenes del Material",
          resource: "Materiales promocionales",
          action: "update",
          navActiveLink: "materiales.promocionales",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "materiales.promocionales" },
            },
            { text: "Imagenes", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Preguntas Frecuentes Faqs
  /****************************************/
  {
    path: "/faqs",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "faq.list",
        component: () => import("views/faqs/list.vue"),
        meta: {
          pageTitle: "Preguntas Frecuentes",
          resource: "Preguntas frecuentes",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "create",
        name: "faq.create",
        component: () => import("views/faqs/create.vue"),
        meta: {
          pageTitle: "Crear Pregunta Frecuente",
          resource: "Preguntas frecuentes",
          action: "write",
          navActiveLink: "faq.list",
          breadcrumb: [
            {
              text: "Preguntas Frecuentes",
              active: false,
              to: { name: "faq.list" },
            },
            { text: "Crear", active: true },
          ],
        },
      },
      {
        path: ":id/edit",
        name: "faq.edit",
        props: true,
        component: () => import("views/faqs/edit.vue"),
        beforeEnter: (to, from, next) => {
          const faq_store = useFaqStore();
          faq_store
            .fetch(to.params.id)
            .then(({ id }) => {
              if (id) {
                next();
              } else {
                next({ name: "faq.list" });
              }
            })
            .catch(() => next({ name: "faqs.list" }));
        },
        meta: {
          pageTitle: "Editar Pregunta Frecuente",
          resource: "Preguntas frecuentes",
          action: "update",
          navActiveLink: "faq.list",
          breadcrumb: [
            {
              text: "Preguntas Frecuentes",
              active: false,
              to: { name: "faq.list" },
            },
            { text: "Editar", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Objetivos
  /*************************************** */
  {
    path: "/objetivos",
    component: ViewsComponent,
    children: [
      {
        path: "",
        component: () => import("views/objetivos/list.vue"),
        name: "objetivos.list",
        meta: {
          pageTitle: "Objetivos",
          resource: "Objetivos",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: ":id/edit",
        component: () => import("views/objetivos/edit.vue"),
        name: "objetivos.edit",
        props: true,
        beforeEnter: (to, from, next) => {
          const objetivo_store = useObjetivoStore();
          objetivo_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Objetivos",
          resource: "Objetivos",
          action: "update",
          navActiveLink: "objetivos.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "objetivos.list" } },
            { text: "Editar", active: true },
          ],
        },
      },
      {
        path: "create",
        component: () => import("views/objetivos/create.vue"),
        name: "objetivos.create",
        meta: {
          pageTitle: "Objetivos",
          resource: "Objetivos",
          action: "write",
          navActiveLink: "objetivos.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "objetivos.list" } },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: "ordenar",
        component: () => import("views/objetivos/ordenar.vue"),
        name: "objetivos.ordenar",
        meta: {
          pageTitle: "Ordenar Objetivos",
          resource: "Objetivos",
          action: "write",
          navActiveLink: "objetivos.list",
          breadcrumb: [
            { text: "Listado", active: false, to: { name: "objetivos.list" } },
            { text: "Ordenamiento", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Tienda de clientes
  /*************************************** */
  {
    path: "/tienda",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "tienda",
        props: (route) => ({
          categoria: route.query.categoria,
          isStore: true,
        }),
        component: () => import("views/productos/list.vue"),
        meta: {
          resource: "Tienda",
          action: "read",
          pageTitle: "Tienda de productos y servicios",
        },
      },
      {
        path: "producto/:id/show",
        props: (route) => ({
          isStore: route.query.isStore || false,
          id: route.params.id,
        }),
        component: () => import("views/productos/perfil.vue"),
        name: "tienda.producto.show",
        beforeEnter: (to, from, next) => {
          fetchProducto(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          resource: "Tienda",
          action: "read",
          pageTitle: "Producto",
          navActiveLink: "tienda",
          breadcrumb: [
            { text: "Tienda", active: false, to: { name: "tienda" } },
            {
              text: (route) => {
                const producto_store = useProductoStore();
                const { producto } = storeToRefs(producto_store);
                return producto.value.nombre;
              },
              active: true,
            },
          ],
        },
      },

      {
        path: "caja",
        name: "caja",
        component: () => import("views/tienda/caja.vue"),
        meta: {
          resource: "Tienda",
          action: "read",
          pageTitle: "Caja",
          breadcrumb: [
            { text: "tienda", to: { name: "tienda" }, active: false },
            { text: "caja", active: true },
          ],
        },
      },
    ],
  },

  /*****************************************/
  /* Página de Unirme de colboradores...
  /*************************************** */
  {
    path: "/aceptar-invitacion",
    name: "aceptar-invitacion",
    component: () => import("views/biografias/AceptarInvitacion.vue"),
    props: (route) => ({ token: route.query.token }),
    beforeEnter: (to, from, next) => {
      const invitacion_store = useInvitacionStore();
      invitacion_store
        .fetchInvitacionPorToken(to.query.token)
        .then(({ id }) => {
          if (id) {
            next();
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    meta: {
      layout: "full",
      resource: "Auth",
      action: "read",
    },
  },

  {
    path: "/panel",
    component: ViewsComponent,
    children: [
      {
        path: "salon-de-los-inmortales",
        name: "salon.inmortales",
        component: () => import("views/salon-inmortales/list.vue"),
        meta: {
          pageTitle: "Salón de los Inmortales",
          resource: "Salón de los Inmortales",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  /*********************************************/
  /* Solicitudes de afiliacion
  /**********************************************/
  {
    path: "/solicitudes-afiliacion",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "solicitud.list",
        component: () => import("views/solicitudes/list.vue"),
        meta: {
          pageTitle: "Solicitudes de Afiliación",
          resource: "Solicitudes",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
    ],
  },

  /*********************************************/
  /* Biografías Beneficiables
  /**********************************************/
  {
    path: "/biografias-beneficiables",
    component: ViewsComponent,
    children: [
      {
        path: "",
        name: "listar.biografias_beneficiables",
        component: () => import("views/beneficiables/biografias/list.vue"),
        meta: {
          pageTitle: "Biografías Beneficiables",
          pageSubtitle:
            "Listado de Configuraciones prestablecidas para biografías que se pueden beneficiar a traves de cupones o productos.",
          resource: "Biografias beneficiables",
          action: "read",
          breadcrumb: [{ text: "Listado", active: true }],
        },
      },
      {
        path: "registrar",
        name: "create.biografias_beneficiable",
        component: () => import("views/beneficiables/biografias/create.vue"),
        meta: {
          pageTitle: "Registrar Biografía Beneficiable",
          resource: "Biografias beneficiables",
          action: "write",
          navActiveLink: "listar.biografias_beneficiables",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.biografias_beneficiables" },
            },
            { text: "Crear", active: true },
          ],
        },
      },

      {
        path: ":id/edit",
        name: "edit.biografias_beneficiable",
        component: () => import("views/beneficiables/biografias/edit.vue"),
        props: true,
        beforeEnter: (to, from, next) => {
          const configuracion_store = useConfiguracionStore();
          configuracion_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },

        meta: {
          pageTitle: "Actualizar Biografía Beneficiable",
          resource: "Biografias beneficiables",
          action: "update",
          navActiveLink: "listar.biografias_beneficiables",
          breadcrumb: [
            {
              text: "Listado",
              active: false,
              to: { name: "listar.biografias_beneficiables" },
            },
            { text: "Actualizar", active: true },
          ],
        },
      },
    ],
  },

  /*********************************************/
  /* Páginas publicas
  /**********************************************/
  {
    path: "/",
    component: () => import("views/public/index.vue"),
    children: [
      // pagina principal
      {
        path: "",
        name: "welcome",
        component: () => import("views/public/welcome.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // autores por encargos
      {
        path: "/autores-por-encargo",
        name: "autors.encargo",
        component: () => import("views/public/AutoresEncargo.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },

      {
        path: "/autor/:slug/perfil",
        name: "autor.perfil",
        component: () => import("views/public/PerfilAutor.vue"),
        props: true,
        beforeEnter: (to, from, next) => {
          const user_store = useUsuarioStore();
          user_store
            .fetchPublicAutor(to.params.slug)
            .then(({ id }) => {
              if (id) {
                next();
              }
            })
            .catch((e) => {});
        },

        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },

      // Aviso legal
      {
        path: "aviso-legal",
        name: "aviso.legal",
        component: () => import("views/public/AvisoLegal.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // Politica de privacidad
      {
        path: "politica-privacidad",
        name: "politica.privacidad",
        component: () => import("views/public/PoliticaPrivacidad.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // Condiciones de ventas
      {
        path: "condiciones-venta",
        name: "condiciones.venta",
        component: () => import("views/public/CondicionesVenta.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // contacto

      {
        path: "contacto",
        name: "contacto",
        component: () => import("views/public/Contacto.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // Conviertete en promotor
      {
        path: "afiliarme",
        name: "solicitud.afiliados",
        props: (route) => ({ aspiracion: route.query.aspiracion }),
        component: () => import("views/public/SolicitudAfiliado.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },

      // Comenzar una Biografía
      {
        path: "comenzar-biografia",
        name: "comenzar.biografia",
        component: () => import("views/public/ComenzarBiografia.vue"),
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },
      // Salon de los inmortales
      {
        path: "salon-de-los-inmortales",
        name: "salon.list",
        component: () => import("views/public/SalonInmortales.vue"),
        props: (route) => ({
          publico: true,
        }),
        meta: {
          layout: "full",
          resource: "Auth",
          action: "read",
        },
      },

      {
        path: "tienda-publica",
        name: "tienda.public",
        props: (route) => ({
          categoria: route.query.categoria,
          isStore: true,
        }),
        component: () => import("views/productos/list.vue"),
        meta: {
          layout: "full",
          resource: "Auth",
          action: "read",
          pageTitle: "Tienda de productos y servicios",
        },
      },
      {
        path: "tienda-publica/producto/:id/show",
        props: (route) => ({
          isStore: true,
          id: route.params.id,
        }),
        component: () => import("views/productos/perfil.vue"),
        name: "tienda.public.producto.show",
        beforeEnter: (to, from, next) => {
          fetchProducto(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          action: "read",
          resource: "Auth",
          pageTitle: "Producto",
          layout: "full",
        },
      },
      {
        path: "solicitud-encargos/:solicitud_id/show",
        name: "solicitud.encargo.show.public",
        component: () => import("views/solicitudes/encargos/solicitud.vue"),
        beforeEnter: (to, from, next) => {
          const solicitud_store = useSolicitudEncargoStore();
          solicitud_store
            .fetchToPublic(to.params.solicitud_id)
            .then((result) => {
              if (result.result) {
                next();
              } else {
                next({ name: "error-404" });
              }
            })
            .catch((e) => {
              next({ name: "error-404" });
            });
        },
        meta: {
          layout: "full",
          resource: "Auth",
          action: "read",
        },
      },
      /*****************************************/
      /* Página para canjear regalo
      /*************************************** */
      {
        path: "/regalos/abrir",
        props: (route) => ({
          token: route.query.token,
        }),
        name: "abrir.regalo",
        component: () => import("views/public/AbrirRegalo.vue"),
        beforeEnter: (to, from, next) => {
          const regalo_store = useRegaloStore();
          regalo_store
            .abrir(to.query.token)
            .then(({ regalo, result, mensaje }) => {
              if (result) {
                next();
              } else {
                next();
                toast.error(mensaje || "No se pudo abrir el regalo");
              }
            })
            .catch((e) => {
              swal({
                title: "Error, no se pudo abrir el regalo",
                text: "No se encontró el regalo o ya fue canjeado",
                icon: "error",
              }).then(() => {
                next({ name: "welcome" });
              });
            });
        },
        meta: {
          layout: "full",
          action: "read",
          resource: "Auth",
        },
      },

      {
        path: "salon-de-los-inmortales",
        component: () => import("views/public/SalonInmortales.vue"),
        name: "salon.inmortales.public",

        meta: {
          layout: "full",
          resource: "Auth",
          action: "read",
        },
      },
    ],
  },

  /*****************************************/
  /* Inbox de Mensajes Bandeja de entradas
  /*************************************** */
  {
    path: "/inbox",
    children: [
      {
        path: "",
        name: "inbox",
        props: (route) => ({
          contacto: route.query.contacto || null,
        }),
        component: () => import("views/inbox/bandeja.vue"),

        beforeEnter: (to, from, next) => {
          if (to.query.contacto) {
            const chat_store = useChatStore();
            chat_store
              .fetchChatContacto(to.query.contacto)
              .then((ch) => {
                if (ch) {
                  next();
                } else {
                  next({ name: "inbox" });
                }
              })
              .catch((e) => {
                next({ name: "inbox" });
              });
          } else {
            next();
          }
        },

        meta: {
          pageTitle: "Bandeja de entrada",
          resource: "Inbox",
          action: "read",
        },
      },
    ],
  },

  /*****************************************/
  /* Autor por encargo configurar
  /*************************************** */
  {
    path: "/autor/por-encargo",
    children: [
      {
        path: "",
        name: "configurar.autor.encargo",
        component: () => import("views/autor-encargo/configurar.vue"),
        beforeEnter: (to, from, next) => {
          const autor_store = useAutorStore();
          autor_store.fetchPorUser().then((autor) => {
            if (!autor.id) {
              preguntar(
                {
                  title: "Perfil de autor no encontrado",
                  html: `<p>No se ha encontrado su perfil de autor por encargo, por favor realice la solicitud.</p>
                <p>¿Desea llenar el formulario de solicitud ahora?</p>`,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonText: "Si, solicitar ahora",
                },
                () => {
                  next({
                    name: "solicitud.afiliados",
                    query: { aspiracion: "autor" },
                  });
                }
              );
            } else {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Perfil de autor por encargo",
          pageSubtitle:
            "Configure su perfil de autor por encargo para recibir solicitudes de biografías personalizadas.",
          resource: "Perfil de autor por encargos",
          action: "read",
        },
      },
      {
        path: "solicitudes/encargos",
        name: "solicitud.encargo.list",
        component: () => import("views/solicitudes/encargos/list.vue"),
        meta: {
          pageTitle: "Solicitudes de Encargo",
          resource: "Encargos",
          action: "read",
          breadcrumb: [
            {
              text: "Solicitudes",
              active: true,
            },
          ],
        },
      },
      {
        path: "encargos",
        name: "encargo.list",
        component: () => import("views/autor-encargo/encargos/list.vue"),
        meta: {
          pageTitle: "Encargos de Biografías",
          resource: "Encargos",
          action: "read",
        },
      },
      {
        path: "encargo/:id/detalles",
        name: "encargo.detalles",
        props: true,
        component: () => import("views/autor-encargo/encargos/detalles.vue"),
        beforeEnter: (to, from, next) => {
          const usuario_store = useUsuarioStore();
          const { usuario_id } = storeToRefs(usuario_store);

          if (!usuario_id.value) {
            localStorage.setItem("redirect_after_login", to.fullPath);
            next({ name: "login" });
            return;
          }

          const encargo_store = useEncargoStore();
          encargo_store.fetch(to.params.id).then(({ id }) => {
            if (id) {
              next();
            }
          });
        },
        meta: {
          pageTitle: "Detalles del Encargo",
          resource: "Encargos",
          action: "read",
          navActiveLink: "encargo.list",
          breadcrumb: [
            {
              text: "Listado de encargos",
              active: false,
              to: { name: "encargo.list" },
            },
            {
              text: "Detalles del encargo",
              active: true,
            },
          ],
        },
      },
    ],
  },

  {
    path: "/encargo/:id/detalles",
    name: "detalles.de.encargo",
    redirect: (to) => {
      localStorage.setItem("redirect_after_login", to.fullPath);
      return { name: "encargo.detalles", params: { id: to.params.id } };
    },
    meta: {
      resource: "Auth",
      action: "read",
    },
  },

  /*****************************************/
  /* PAGINA DE Mantenimiento
   /*************************************** */
  {
    path: "/mantenimiento",
    name: "show.mantenimiento",
    component: () => import("views/mantenimiento/index.vue"),
    meta: {
      layout: "full",
      action: "read",
      resource: "Auth",
    },
  },
];
